import React from 'react';
import PropTypes from 'prop-types';
import { Link, NavLink, useNavigate } from 'react-router';
import Icon from '@mui/material/Icon';

import logoGeneric from '../../assets/images/logo.png';
import logoQC from '../../assets/images/logo-qc.png';
import logoBSL from '../../assets/images/logo-bsl.png';

import { routes } from '../../constants';

import { userActions } from '../../actions';
import { connect } from 'react-redux';
import { UserType } from '../../pages/User/User';

function Header({ user, rank, logoutUser }) {
  const navigate = useNavigate();

  const handleLogout = e => {
    e.preventDefault();
    logoutUser();
    navigate('/login');
  };

  return (
    <header className="general-header">
      <nav className="container">
        <Link to="/" className="home-link">
          <img
            alt="logo"
            src={
              user.logo === 'bsl'
                ? logoBSL
                : user.logo === 'qc'
                  ? logoQC
                  : logoGeneric
            }
          />
        </Link>

        <div className="primary-links">
          {routes.map(
            route =>
              route.allowed.indexOf(rank) !== -1 &&
              route.main && (
                <NavLink
                  key={route.path}
                  className={({ isActive }) =>
                    route.children
                      ? 'has-subroutes'
                      : '' +
                        (isActive
                          ? ` active border-fill text-fill ${route.class}`
                          : '')
                  }
                  to={route.path}
                >
                  <Icon>{route.icon}</Icon>
                  {route.display}

                  <span className="subroutes">
                    {route.children &&
                      route.children.map((c, index) => (
                        <Link key={index} to={c.path}>
                          {c.display}
                        </Link>
                      ))}
                  </span>
                </NavLink>
              )
          )}
        </div>

        <div className="secondary-links">
          <Link to={'/users/' + user.id} className="user-link">
            {user.name + ' ' + user.surname}
            <small>{(user.user_type || {}).label}</small>
          </Link>

          <a onClick={handleLogout} className="logout-button">
            <Icon>logout</Icon>
          </a>
        </div>
      </nav>
    </header>
  );
}

Header.propTypes = {
  user: UserType,
  rank: PropTypes.number,
  logoutUser: PropTypes.func,
};

const mapStateToProps = state => {
  return {
    user: state.user.infos,
    rank: (state.user.infos.user_type || {}).rang,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    logoutUser: () => dispatch(userActions.logout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
